
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find-and-remove-revenge-porn",
      function () {
        return require("private-next-pages/find-and-remove-revenge-porn.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find-and-remove-revenge-porn"])
      });
    }
  